// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from 'react';
import {
  PlasmicServices,
  DefaultServicesProps,
} from './plasmic/paziresh_24/PlasmicServices';
import { HTMLElementRefOf } from '@plasmicapp/react-web';
import { CENTERS } from '@/common/types/centers';
import { useOnlineVisitFirstAvailable } from '@/modules/profile/hooks/useOnlineVisitFirstAvailable';
import { onlineVisitCtaButtonProps } from '@/modules/profile/utils/formatOnlineVisitApproxTime';
import { replaceOnlineVisitHeading } from '@/modules/profile/utils/replaceOnlineVisitHeading';
import { onlineVisitAbsentScoreUrl } from '@/common/apis/services/ravi/absentScore';
import { useOnlineVisitPriceWithVat } from '@/common/utils/onlineVisitPriceWithVat';
import { useCorporateProfilePrice } from '@/modules/corporate/livePrices';

export interface ServicesProps extends DefaultServicesProps {}

const hideConsultWaitingTime = (waitingTimeInfo: unknown) => {
  if (!Array.isArray(waitingTimeInfo)) return waitingTimeInfo;
  return waitingTimeInfo.map(item =>
    String(item?.center_id) === CENTERS.CONSULT ? { ...item, waiting_time_title: undefined } : item,
  );
};

function Services_(props: ServicesProps, ref: HTMLElementRefOf<'div'>) {
  const slug = typeof props.seo?.slug === 'string' ? props.seo.slug : '';
  const isOnlineVisit = props.type === 'onlineVisit';
  const { freeturnMs } = useOnlineVisitFirstAvailable({
    enabled: isOnlineVisit,
    serviceId: props.service?.id != null ? String(props.service.id) : undefined,
    userCenterId: props.service?.user_center_id != null ? String(props.service.user_center_id) : undefined,
  });
  const ctaButton = onlineVisitCtaButtonProps(freeturnMs);
  const onlinePriceWithVat = useOnlineVisitPriceWithVat('profile');
  // «ویزیت آنلاین سازمانی»: null for everyone but the one rolled-out account (corporate/rollout.ts)
  const corporatePrice = useCorporateProfilePrice(isOnlineVisit ? props.service?.free_price : undefined, onlinePriceWithVat);
  const onlineAbsentFetcher =
    isOnlineVisit && slug
      ? { props: { url: onlineVisitAbsentScoreUrl(slug) } }
      : undefined;

  if (!isOnlineVisit) {
    return <PlasmicServices root={{ props: { ref } }} {...props} httpRestApiFetcher={onlineAbsentFetcher} />;
  }

  return (
    <PlasmicServices
      root={{
        // wrapChildren only applies when override has a `props` key (or only wrap*).
        props: { ref, 'data-new-online-visit-box': 'on' },
        wrapChildren: replaceOnlineVisitHeading,
      }}
      {...props}
      httpRestApiFetcher={onlineAbsentFetcher}
      waitingTimeInfo={hideConsultWaitingTime(props.waitingTimeInfo)}
      button={{ ...ctaButton, 'data-profile-booking-cta': 'online' } as any}
      priceSlot={corporatePrice ?? undefined}
    />
  );
}

const Services = React.forwardRef(Services_);
export default Services;
